import { gql } from "@apollo/client";

export const fetchIncidents = gql`
    query fetchIncidents ($companyId: uuid!) {
        incidents (where: {companyId: {_eq: $companyId}}) {
            id
            description
            enabled
            causes_aggregate {
                aggregate {
                    count(columns: incidentId)
                }
            }
        }
    }
`;

export const insertIncident = gql`
    mutation insertIncident($description: String!, $enabled: Boolean!, $companyId: uuid!) {
        insert_incidents(objects: {description: $description, enabled: $enabled, companyId: $companyId}) {
            affected_rows
            returning {
                id
            }
        }
    }
`;

export const updateIncident = gql`
    mutation udateIncident($id: uuid!, $description: String!, $enabled: Boolean!) {
        update_incidents(_set: {description: $description, enabled: $enabled}, where: {id: {_eq: $id}}) {
            affected_rows
        }
    }
`;

export const deleteIncident = gql`
    mutation deleteIncident($id: uuid!) {
        delete_incidents(where: {id: {_eq: $id}}) {
            affected_rows
        }
    }
`;